const TEACHER_PATH = /^\/teacher(?:\/[A-Za-z0-9._~-]+)*(?:\?[A-Za-z0-9._~=&%-]*)?$/;

export const PROFILE_INCOMPLETE_REASON = 'profil-incomplet';

export function safeTeacherNext(raw: string | null | undefined): string | null {
  if (!raw || raw.length > 200) return null;
  if (!TEACHER_PATH.test(raw)) return null;
  if (raw.split('?')[0]!.split('/').some((segment) => segment === '..')) return null;
  return raw;
}

export function onboardingHref(path: '/onboarding' | '/onboarding/classes' | '/onboarding/preferences', next: string | null): string {
  if (!next) return path;
  const params = new URLSearchParams({ next });
  if (path === '/onboarding') params.set('reason', PROFILE_INCOMPLETE_REASON);
  return `${path}?${params.toString()}`;
}

export function onboardingDoneTarget(rawNext: string | null): string {
  return safeTeacherNext(rawNext) ?? '/teacher';
}
